import axios from "axios";
import apiConfig from "../config";

// Smart resolution for apiUrl: handles both direct string export and object export (e.g. { apiUrl })
const apiUrl =
  apiConfig && apiConfig.apiUrl
    ? apiConfig.apiUrl.trim()
    : apiConfig
      ? apiConfig.trim()
      : "";

export const getallproperties = async (params) => {
  try {
    const response = await axios.get(
      `${apiUrl}/property/getallproperties`,
      params ? { params } : undefined,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching properties:", error);
    return [];
  }
};

export const ContactUs = async (formData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/contactus/createcontactus`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const createPropertyEnquiry = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrl}/propertyenquiry/createpropertyenquiry`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const searchProperties = async (params) => {
  try {
    const response = await axios.get(`${apiUrl}/property/getallproperties`, {
      params,
    });
    return response.data.properties;
  } catch (error) {
    console.error(error);
  }
};

export const getalllocations = async () => {
  try {
    const response = await axios.get(`${apiUrl}/property/getlocations`);
    if (response.data && response.data.locations) {
      return response.data.locations;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else {
      console.error(
        "Unexpected response format from getlocations API:",
        response.data,
      );
      return [];
    }
  } catch (error) {
    console.error("Error fetching locations:", error);
    return [];
  }
};

export const getallcities = async () => {
  try {
    const response = await axios.get(`${apiUrl}/property/getpropertycities`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch cities");
    throw error;
  }
};

export const getPropertyById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/property/getproperties/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch property by ID:", error);
    throw error;
  }
};

export const getallBlogs = async () => {
  try {
    const response = await axios.get(`${apiUrl}/blog/getallblogs`);
    return response.data.blog;
  } catch (error) {
    console.error("Failed to fetch blogs");
    throw error;
  }
};

export const createLoanInquiry = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrl}/loaninqueries/createloaninquiries`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating loan inquiry:", error);
    throw error;
  }
};

export const createInteriorDesignInquiry = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrl}/interiordesignenqueries/createinteriordesignenquery`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating interior design inquiry:", error);
    throw error;
  }
};

export const getAllPlots = async (params) => {
  try {
    const response = await axios.get(
      `${apiUrl}/plots/getallplots`,
      params ? { params } : undefined,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching plots:", error);
    return [];
  }
};

export const getPlotById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/plots/getplot/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch plot by ID:", error);
    throw error;
  }
};

export const getCitiesByStateAdmin = async (params) => {
  try {
    const response = await axios.get(`${apiUrl}/cities/getcitiesbystate`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error, "error");
  }
};

export const getAllCitiesAdmin = async () => {
  try {
    const response = await axios.get(`${apiUrl}/cities/getallcitiesadmin`);
    if (
      response.data &&
      response.data.status === true &&
      Array.isArray(response.data.data)
    ) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error in getAllCitiesAdmin:", error);
    return [];
  }
};

export const getRecentProperties = async (params = {}) => {
  try {
    const response = await axios.get(`${apiUrl}/property/getrecentproperties`, {
      params,
    });
    if (response.data && response.data.status === true) {
      return response.data.data || [];
    }
    return [];
  } catch (error) {
    console.error("Error fetching recent properties:", error);
    return [];
  }
};

export const getAllstatesAdmin = async (params) => {
  try {
    const response = await axios.get(`${apiUrl}/states/getallstates`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(error, "error");
  }
};

// Showcase Projects Frontend API
export const getAllProjectsFrontend = async () => {
  try {
    const response = await axios.get(`${apiUrl}/projects/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching frontend projects:", error);
    return { status: false, message: error.message };
  }
};
